window._ = require('lodash');

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');
    window.AOS = require('aos');

    require('bootstrap');
    require('./lazysizes.min.js');

    // console.log( 'aos -- >', typeof AOS );
    AOS.init();
    
} catch (e) { }

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

